import { Component, ViewChild, ElementRef } from '@angular/core';
import { NavController, NavParams, AlertController, LoadingController, ToastController } from 'ionic-angular';
import { DIC } from '../dic';
import { GN } from '../../gn';
import { FormControl, FormBuilder, FormGroup } from "@angular/forms";




/**
 * Generated class for the AddtickedPage page.
 *
 * See https://ionicframework.com/docs/components/#navigation for more info on
 * Ionic pages and navigation.
 */

@Component({
  selector: 'page-addticked',
  templateUrl: 'addticked.html',
})
export class AddtickedPage {

  @ViewChild("myfile") fileInput: ElementRef;
  @ViewChild("myfile2") fileInput2: ElementRef;

  loadingData: boolean = false
  _category = 0
  _problem = 0
  _priorityid = 0
  _nameproblem = ''
  _shortdescription = ''

  categoryArr = []
  problemArr = []
  _toolbars: any

  item: any;

  documents = []
  photoPath = ''
  editUpload: boolean = false;
  showAddNewProdTemplate: boolean = false;

  ti: any
  Title = ''
  doc: any
  myToast: any
  _detalno = ''






  constructor(public navCtrl: NavController, public navParams: NavParams, public dic: DIC, public gn: GN, private formBuilder: FormBuilder, public alertCtrl: AlertController, public loadingCtrl: LoadingController, public toastCtrl: ToastController) {
    this.ti = navParams.get('ti')
    // if (this.ti != undefined) {
    //   this.Title = this.dic.l["addJob"]
    // }
    // else {
    console.log(this.ti, 'daj mi ti')
    if (this.ti.id == -1) {
      this.Title = this.dic.l["Addticket"]
    } else {
      this.documents = []
      this.documents = navParams.get('doc')
      console.log(this.doc, 'daj da vidam')
      this._nameproblem = this.ti.name
      this.Title = this.dic.l["Editticket"] + ' ' + this._nameproblem
      this._category = this.ti.categoryid
      this._problem = this.ti.problemid
      this._shortdescription = this.ti.shortdescription
      this._priorityid = this.ti.priorityid
      this._detalno = this.ti.detaildescription
    }
  }



  ionViewDidLoad() {
    // this.item = this.formBuilder.control('');
    // console.log(this.item, 'daj da vidam sto se slucuva')


    console.log('ionViewDidLoad AddtickedPage');
    this.loadCategory()
    this.loadProblem()
  }

  // ionViewWillLoad() {
  //   this.item = this.formBuilder.control('');
  //   if (this.ti.id != -1) {
  //     this.item.value = this.ti.detaildescription
  //   }
  // }

  loadCategory() {
    this.loadingData = true
    var _that = this
    this.gn._Post('/api/gn/getCategoryTicket', {}, function (_data) {
      _that.categoryArr = _data
      _that.loadingData = false
    })
  }

  loadProblem() {
    this.loadingData = true
    var _that = this
    this.gn._Post('/api/gn/getProblemTicked', {}, function (_data) {
      _that.problemArr = _data
      _that.loadingData = false
    })
  }


  getFileExtension(_fname) {
    var tmp = _fname.split('.')
    if (tmp.length > 0) {
      return tmp[tmp.length - 1].toLocaleLowerCase()
    } else {
      return ""
    }
  }
  fileChange(e) {
    var isValidExtension = true
    var allowedExtensions = ["png", "jpg", "jpeg", "gif", "svg", "pdf"]

    var fls = e.target.files
    for (var i = 0; i < fls.length; i++) {
      var _ext = this.getFileExtension(fls[i].name)
      // console.log(_ext)
      if (allowedExtensions.indexOf(_ext) == -1) { isValidExtension = false }
      if (isValidExtension == true) {
        this.uploadFile()
      } else {
        const alert = this.alertCtrl.create({
          title: 'invalid file',
          subTitle: 'format ' + allowedExtensions.join(', '),
          buttons: ['OK']
        });
        alert.present();
      }
      // console.log(isValidExtension)
    }
  }

  uploadFile() {
    var _loader = this.loadingCtrl.create({
      content: 'upload',
      duration: 3000
    });
    _loader.present();

    var _that = this
    var file = (<HTMLInputElement>document.getElementById('postImage')).files[0];
    var reader: any = new FileReader();
    reader.onload = function (e) {
      // var rawData = new ArrayBuffer();
      var _data = e.target.result
      // console.log(e.target.result);
      // console.log()
      if (e.target.result.length > 10000000) {
        var bytes = _that.gn.tByte(reader.result.length)
        const alert = _that.alertCtrl.create({
          title: 'largefile',
          subTitle: 'filemustbe' + bytes,
          buttons: ['OK']
        });
        alert.present();
        return
      }
      var _poz = _data.indexOf('base64,')
      var _data2 = _data.substring(_poz + 7)

      var _uinq = _that.gn.rndCode() + '-' + _that.gn.rndCode() + '-' + _that.gn.rndCode()

      var _ext = _that.getFileExtension(file.name)

      _that.gn._PostUploadFile('/api/gn/uploadtempphoto', { file: _data2, ext: _that.gn.crypt(_ext), uniq: _that.gn.crypt(_uinq) }, function (_data) {
        _loader.dismiss()
        console.log('vlagas tuka mozebi da')
        _that.photoPath = _uinq + '.' + _ext
      })

    }

    reader.readAsDataURL(file);
  }

  uploadFileTraining() {
    this.fileInput2.nativeElement.click();

  }
  getFileExtensionTraining(_fname) {
    var tmp = _fname.split('.')
    if (tmp.length > 0) {
      return tmp[tmp.length - 1].toLocaleLowerCase()
    } else {
      return ""
    }
  }
  fileChangeTraining(e) {
    var isValidExtension = true
    var allowedExtensions = ["png", "jpg", "jpeg", "gif", "svg", "pdf"]

    var fls = e.target.files
    for (var i = 0; i < fls.length; i++) {
      var _ext = this.getFileExtensionTraining(fls[i].name)
      if (allowedExtensions.indexOf(_ext) == -1) { isValidExtension = false }
      if (isValidExtension == true) {
        this.doUploadFileTraining()
      } else {
        const alert = this.alertCtrl.create({
          title: 'invalidfile',
          subTitle: 'formatmustbe' + allowedExtensions.join(', '),
          buttons: ['OK']
        });
        alert.present();
      }

    }
  }

  loadData() {

  }

  doUploadFileTraining() {
    var _loader = this.loadingCtrl.create({
      content: this.dic.l["Uploading"],
      duration: 3000
    });
    _loader.present();
    var _that = this
    var file = this.fileInput2.nativeElement.files[0];
    var reader: any = new FileReader();
    reader.onload = function (e) {
      var _data = e.target.result
      if (e.target.result.length > 10000000) {
        var bytes = _that.gn.tByte(reader.result.length)
        const alert = _that.alertCtrl.create({
          title: 'largefile',
          subTitle: 'filemustbe' + bytes,
          buttons: ['OK']
        });
        alert.present();
        _loader.dismiss()
        return
      }
      var _poz = _data.indexOf('base64,')
      var _data2 = _data.substring(_poz + 7)

      var _uinq = _that.gn.rndCode() + '-' + _that.gn.rndCode() + '-' + _that.gn.rndCode()
      var _ext = _that.getFileExtension(file.name)

      _that.gn._PostUploadFile('/api/gn/addfiletraining', { file: _data2, ext: _that.gn.crypt(_ext), uniq: _that.gn.crypt(_uinq) }, function (_data) {
        _that.addDoctoList(file.name, _uinq, _ext)
        _loader.dismiss()
      })

    }
    reader.readAsDataURL(file);
  }

  addDoctoList(_originFilename, _uniq, _ext) {
    var _that = this
    _that.documents.push({ photo: '/api/gn/preview/' + _uniq + '.' + _ext, filename: _uniq, originalfilename: _originFilename, orderno: _that.documents.length + 1, ext: _ext })
    // console.log(_that.documents)
  }

  deleteDocReoder(index: number) {
    if (this.ti.id != -1) {
      var _that = this
      this.gn._Post('/api/gn/delTicketDocs', { id: this.gn.crypt(this.ti.id), idx: this.gn.crypt(index) }, function (_data) {
      })
    }
    this.documents.splice(index, 1);
  }


  clearValuesTraining() {
    this._category = 0
    this._problem = 0
    this._priorityid = 0
    this._nameproblem = ''
    this.documents = []
    this._shortdescription = ''
    this.editUpload = false;

  }

  choosecat() {
    this._problem = 0
  }


  uploadMyNewProduct() {
    // console.log(this._detalno, '_detalno')
    if (this.myToast != null) {
      return
    }

    if (this._category + '' == '0') {
      let alert = this.alertCtrl.create({ title: this.dic.l["error"], subTitle: this.dic.l["addcategory"], buttons: [this.dic.l['ok']] });
      alert.present();
      return
    }

    if (this._problem + '' == '0') {
      let alert = this.alertCtrl.create({ title: this.dic.l["error"], subTitle: this.dic.l["addproblem"], buttons: [this.dic.l['ok']] });
      alert.present();
      return
    }

    if (this._nameproblem + '' == '') {
      let alert = this.alertCtrl.create({ title: this.dic.l["error"], subTitle: this.dic.l["addnameproblem"], buttons: [this.dic.l['ok']] });
      alert.present();
      return
    }

    if (this._shortdescription + '' == '') {
      let alert = this.alertCtrl.create({ title: this.dic.l["error"], subTitle: this.dic.l["addshortdescription"], buttons: [this.dic.l['ok']] });
      alert.present();
      return
    }

    if (this._priorityid + '' == '0') {
      let alert = this.alertCtrl.create({ title: this.dic.l["error"], subTitle: this.dic.l["addpriorityid"], buttons: [this.dic.l['ok']] });
      alert.present();
      return
    }

    var _that = this;
    // var _loader = this.loadingCtrl.create({
    //   content: this.dic.l["Uploading"],
    //   duration: 3000
    // });
    // _loader.present();

    console.log(this.ti.id, 'this.ti.id ti id da vidam')
    var dat = {
      id: this.gn.crypt(this.ti.id),
      category: this.gn.crypt(this._category),
      problem: this.gn.crypt(this._problem),
      nameproblem: this.gn.crypt(this._nameproblem),
      shortdescription: this.gn.crypt(this._shortdescription),
      // detail: this.gn.crypt(this.item.value),
      detail: this.gn.crypt(this._detalno),
      // documents: this.documents,
      priorityid: this.gn.crypt(this._priorityid),
      cid: this.gn.crypt(this.gn.user.ClientId),
      uid: this.gn.crypt(this.gn.user.UserId),
    }
    this.gn._Post('/api/gn/saveticket', dat, function (_data) {
      // _loader.dismiss();
      // if (_that.editUpload) {
      //   _data.msg = _data.msg.replace('uploaded', 'changed')
      // }
      // _that.toastCtrl.create({
      //   message: _that.dic.l[_data.msg],
      //   position: 'top',
      //   duration: 3000
      // });
      // if (_data.msg == 'success-uploaded-ticket' || _data.msg == 'success-changed-ticket') {
      // _that.loadData();
      //  _that.showAddNewProdTemplate = false;
      // _that.editUpload = false;
      // _that.clearValuesTraining();
      // }

      var _cb = _that.navParams.get('cb')
      if (_cb != null) {
        _cb()
      }

    })
    _that.navCtrl.pop();

  }

  addNewTraining() {
    this.showAddNewProdTemplate = true
    this.clearValuesTraining();
  }



}



// WEBPACK FOOTER //
// ./src/pages/ticket/addticked.ts